import React, { useEffect, useState } from 'react'
import BreadCrames from './BreadCrames'
import Loader from '../utils/Loader'
import moment from 'moment'
import ApiConnection from '../utils/ApiConnection'
import { toast } from 'react-toastify'
import { NotificationAction } from '../redux/SidebarSlice'
import { useDispatch } from 'react-redux'

const Notification = () => {
  const [loading, setloading] = useState(false)
  const [Notification, setNotification] = useState([]);

  const dispatch = useDispatch()

  const GetNotification = async ()=>{
  
    try {
        const  response = await ApiConnection.get('user-notification')
        if(response?.status == 200){
            setNotification(response?.data?.data)
               dispatch(NotificationAction(response?.data?.data))
        } else{
          
        }  
    } catch(err){
        
    }
  }

  const ReadHandle = async (id)=>{
    setloading(true)
    try {

        const  response = await ApiConnection.put(`user-notification/${id}`)
        if(response?.status == 200){
          toast(response?.data?.message)
          GetNotification()
            setloading(false)
        } else{
          
        }  
    } catch(err){
        
    }

  }

  useEffect(()=>{
    GetNotification()
  },[])
  

  return (
    <>
    {loading && <Loader/>}
     <BreadCrames page="Notification" />
     <div className='px-4'>
     {Notification?.length > 0 ?
      
      <div className="noti-sec">
        <ul>
          {Notification?.map((notification, i) =>{
            return (
              <li style={{position:'relative'}} key={i}>
                <h5>{notification?.name}</h5>
                <h6>{notification?.subject}</h6>
                <p>{notification?.content}</p>
                <span>{moment(notification?.updated_at).format('DD-MM-YYYY')}</span>
                <button onClick={()=>ReadHandle(notification.id)} className='btn btn-primary' style={{position:'absolute', right:'15px',bottom:'15px'}}>Mark as read</button>
                </li>
            )
          })}
           
        </ul>
       </div>
    :
    <h5>No notification list</h5>
    
    }
       
     </div>
    
 </>
  )
}

export default Notification